






























import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import Hammer from 'hammerjs'

@Component({})
export default class BottomSheetLayout extends Vue {
  @Prop({ default: 0.1 })
  openY!: number

  @Prop({ default: 0.5 })
  halfY!: number

  @Prop({ default: 1 })
  closeY!: number

  @Prop({ default: false })
  isOpen!: boolean

  @Prop({ default: 'rgba(0, 0, 0, .3)' })
  barColor!: string

  y = 0
  startY = 0
  isMove = false
  state = 'close'
  mc: any = {}
  rect: any = {}

  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (scrollTop + clientHeight >= scrollHeight) {
      window.scrollTo(0, 1)
    }
  }

  @Watch('isOpen')
  open() {
    this.setState(this.isOpen ? 'open' : 'close')
  }

  setState(state) {
    this.state = state
    switch (state) {
      case 'close':
      case 'half':
        return this.$emit('update:isOpen', false)
      case 'open':
        return this.$emit('update:isOpen', true)
    }
  }

  calcY() {
    switch (this.state) {
      case 'close':
        return this.rect.height * this.closeY
      case 'open':
        return this.rect.height * this.openY
      case 'half':
        return this.rect.height * this.halfY
      default:
        return this.y
    }
  }

  calcContent() {
    const offset = this.$isSafari() ? 0.21 : 0.12
    switch (this.state) {
      case 'open':
        return this.rect.height * (1 - this.openY - offset)
      case 'half':
        return this.rect.height * (1 - this.halfY - offset)
      default:
        return this.rect.height
    }
  }

  mounted() {
    const refCard = this.$refs.card as any

    // Get the info of bounding card when init
    this.rect = refCard?.getBoundingClientRect()

    // Update info when the browser window is resized
    window.onresize = () => {
      this.rect = refCard?.getBoundingClientRect()
    }

    this.mc = new Hammer(this.$refs.pan)
    this.mc.get('pan').set({ direction: Hammer.DIRECTION_ALL })

    this.mc.on('panup pandown', evt => {
      this.y = evt.center.y - 16
    })

    this.mc.on('panstart', evt => {
      this.startY = evt.center.y
      this.isMove = true
    })

    this.mc.on('panend', evt => {
      this.isMove = false

      // Added a close state on the condition to be able to swipe from closed to half/closed state.
      switch (this.state) {
        case 'close':
        case 'half':
          if (this.state === 'close') {
            if (this.startY - evt.center.y > 120) {
              this.state = 'half'
            }

            if (this.startY - evt.center.y > 320) {
              this.state = 'open'
            }

            break
          }

          if (this.startY - evt.center.y > 120) {
            this.state = 'open'
          }

          if (this.startY - evt.center.y < -50) {
            this.state = 'close'
          }
          break
        case 'open':
          if (this.startY - evt.center.y < -120) {
            this.state = 'half'
          }
          break
      }
    })
  }

  beforeDestroy() {
    this.mc.destroy()
    window.onresize = null
  }
}
